import React from 'react'
import { MessageCircle, ArrowRight } from 'lucide-react'

const HeroSection: React.FC = () => {
  return (
    <section className="hero-gradient relative overflow-hidden">
      {/* Beacon Glow Effect */}
      <div className="beacon-glow absolute top-10 right-10 w-96 h-96 rounded-full opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-6 py-20 lg:py-32">
        <div className="text-center relative z-10">
          {/* Code Beacon SVG Logo */}
          <div className="mb-8">
            <img 
              src="/images/code-beacon-icon-color-3.svg" 
              alt="Code Beacon" 
              width="128" 
              height="128" 
              className="mx-auto mb-6 float-animation" 
            />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            <span className="text-gradient">Illuminating the path</span><br/>
            to smarter, secure,<br/>
            <span style={{ color: 'var(--text)' }}>AI-driven software solutions</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed" style={{ color: 'var(--text-muted)' }}>
            We design and protect intelligent software — secure, scalable, and powered by AI
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="mailto:hello@code-beacon.io" className="btn-primary">
              <MessageCircle className="w-5 h-5 inline mr-2" />
              Talk to Us
            </a>
            <a href="#services" className="btn-secondary">
              <ArrowRight className="w-5 h-5 inline mr-2" />
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection